import React from 'react';

import TagDiscounts from '../TagDiscounts/TagDiscounts';

const ModuleTagsDiscounts = ({
  isMobile,
  tagsDiscounts,
  home,
  primaryColor,
  uiVariantBannerPromo,
  hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics,
  hasGoogleTagManager,
}) => {
  return (
    <TagDiscounts
      isMobile={isMobile}
      tags={tagsDiscounts}
      discountsTitle={home.discountsTitle}
      primaryColor={primaryColor}
      uiVariantBannerPromo={uiVariantBannerPromo}
      hasGoogleAnalytics4Advanced={hasGoogleAnalytics4Advanced}
      hasFarmakomMetrics={hasFarmakomMetrics}
      hasGoogleTagManager={hasGoogleTagManager}
    />
  );
};

export default ModuleTagsDiscounts;
